module.exports = __webpack_public_path__ + "static/media/p-contacts.df52bf05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/p-contacts.svg
// module id = 794
// module chunks = 0